<template>
    <div class="uk-padding uk-margin-remove-top uk-background-muted">
        <h2 class="uk-heading-divider uk-text-center ">Alumni Spotlights</h2>
        <div class="uk-container">
            <div uk-slider="">

                <div class="uk-position-relative uk-visible-toggle " tabindex="-1">

                    <ul class="uk-slider-items uk-child-width-1-1@s uk-child-width-1-3@m uk-grid">
                        <li>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-top">
                                    <img src="../../assets/alumni/gary.jpeg" alt="">
                                </div>
                                <div class="uk-card-body" style="padding: 15px">
                                    <h3 class="uk-card-title">Gary Gardener, Dr</h3>
                                    <p class="uk-text-small">
                                        My experience at NCU was multifaceted for the good.
                                        From working in manual development to building the Tai Center was instrumental in shaping my world view outside of regurgitating concepts and theories.

                                    </p>

                                    <button class="uk-button uk-button-secondary uk-margin-small-right uk-align-right@m uk-text-capitalize uk-text-bold"
                                            type="button" uk-toggle="target: #gary" style="background-color: gold; color: #033860;"
                                    >Read More..</button>

                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-top">
                                    <img class="" src="../../assets/alumni/casey.jpg" alt="">
                                </div>
                                <div class="uk-card-body" style="padding: 15px">
                                    <h3 class="uk-card-title">Casey Maxwell-Roberts</h3>
                                    <p class="uk-text-small">
                                        The Northern Caribbean University provided not only academic but spiritual growth.
                                        Caring, nurturing lecturers provided a sense of emotional well-being by seeking to
                                        ensure that I attained optimal efficiency
                                    </p>

                                    <button class="uk-button uk-button-secondary uk-margin-small-right uk-align-right@m uk-text-capitalize uk-text-bold"
                                            type="button" uk-toggle="target: #casey" style="background-color: gold; color: #033860;"
                                    >Read More..</button>

                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="uk-card uk-card-default">
                                <div class="uk-card-media-top">
                                    <img class="" src="../../assets/alumni/claudine.jpg" alt=""
                                         style="">
                                </div>
                                <div class="uk-card-body" style="padding: 15px">
                                    <h3 class="uk-card-title">Claudine E. Campbell</h3>
                                    <p class="uk-text-small">
                                        The time I have spent at Northern Caribbean University has proved to be most valuable.
                                        It has taught me the true meaning of God’s golden rule “And as ye would that men should
                                        do to you, do ye also to them likewise”
                                    </p>

                                    <button class="uk-button uk-button-secondary uk-margin-small-right uk-align-right@m uk-text-capitalize uk-text-bold"
                                            type="button" uk-toggle="target: #claudine" style="background-color: gold; color: #033860;"
                                    >Read More..</button>

                                </div>
                            </div>
                        </li>

                    </ul>

                    <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                    <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

                </div>

                <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
                <br>
            </div>
        </div>

        <div id="gary" uk-modal>
            <div class="uk-modal-dialog">

                <button class="uk-modal-close-default" type="button" uk-close></button>

                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Gary Gardener</h2>
                </div>

                <div class="uk-modal-body" uk-overflow-auto>

                    <div class="uk-panel">
                        <img class="uk-align-left uk-margin-remove-adjacent" src="../../assets/alumni/gary.jpeg" width="200" height="200" alt="Example image">
                        <p>
                            My experience at NCU was multifaceted for the good.
                            From working in manual development to building the Tai Center was instrumental in shaping my world view outside of regurgitating concepts and theories.
                            My experience was indelible with a number of co-curricular activities; from being the football captain for three years,
                            USM Treasurer, a member of community clubs in Mandeville to name a few.
                            NCU allowed me to become assistant Business manager for Heaven's Texaco while a being a Senior to assist with tuirion payment.
                        </p>
                        <p>
                            The most interesting experience were the Friday night vesper and the week of prayer bi annually.
                            They're spiritual experience has taught me accountability to God living in a country where you are not accountable to anyone.
                            It doesn't matter the challenges you face at NCU, the experience and the wholistic education will definitely prepare you for a life of success.
                        </p>
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-modal-close uk-text-small uk-text-capitalize" type="button">Close</button>

                </div>

            </div>
        </div>
        <div id="casey" uk-modal>
            <div class="uk-modal-dialog">

                <button class="uk-modal-close-default" type="button" uk-close></button>

                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Casey Maxwell-Roberts</h2>
                </div>

                <div class="uk-modal-body" uk-overflow-auto>

                    <div class="uk-panel">
                        <img class="uk-align-left uk-margin-remove-adjacent" src="../../assets/alumni/casey.jpg" width="200" height="200" alt="Example image">
                        <p>
                            The Northern Caribbean University provided not only academic but spiritual growth. Caring,
                            nurturing lecturers provided a sense of emotional well-being by seeking to ensure that I attained
                            optimal efficiency and produced high quality work.
                            Being at NCU has provided the tools for individuals to take on their roles within the workplace with renewed vigor confidence and sound competency.
                        </p>
                        <p>
                            NCU improved my understanding of curriculum and instruction allowing me the opportunity to become a
                            part-time lecturer at the Department of Teacher Education; where I write examination papers for TVET Curriculum for the UWI – Cavehill, Campus.
                            I also function within the institution as a second marker and moderator here in Antigua and Barbuda for TVET Curriculum at UWI - Antigua Campus.
                        </p>
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-modal-close uk-text-small uk-text-capitalize" type="button">Close</button>

                </div>

            </div>
        </div>
        <div id="claudine" uk-modal>
            <div class="uk-modal-dialog">

                <button class="uk-modal-close-default" type="button" uk-close></button>

                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Casey Maxwell-Roberts</h2>
                </div>

                <div class="uk-modal-body" uk-overflow-auto>

                    <div class="uk-panel">
                        <img class="uk-align-left uk-margin-remove-adjacent" src="../../assets/alumni/claudine.jpg" width="200" height="200" alt="Example image">
                        <p>
                            The time I have spent at Northern Caribbean University has proved to be most valuable.
                            It has taught me the true meaning of God’s golden rule “And as ye would that men should do to you,
                            do ye also to them likewise” Luke 6:31KJV. My experiences at this institution have confirmed that
                            all things are possible through Christ. My faith, confidence, and knowledge gained have brought a
                            new dimension into my life to achieve in the face of adversities.
                        </p>
                        <p>
                            The PhD in Education in Educational Administration has widened my knowledge-base as its intensive
                            and comprehensive modules exposed me to different aspects of educational administration.
                            It has positively impacted my approach to administration and improved my administrative skills.
                            It has greatly assisted in preparing me theoretically and practically for the real world.
                            The lecturers must be commended for their utilisation of diverse teaching strategies which
                            facilitated inclusiveness and learning. This degree will improve my professional prospects
                            as I am more equipped to transition to a vocation in academia
                        </p>
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-modal-close uk-text-small uk-text-capitalize" type="button">Close</button>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "alumniStories"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2{
            font-size: 1.1em !important;
        }
        h1{
            font-size: 1.2em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
